import { useState, useEffect } from 'react';
import axios from '../../../../api/axios';

/**
 * 测试用例管理 Hook
 * 负责管理公共测试和秘密测试用例的编辑状态
 */
export function useTestCases(question, questionId, isTeacher = false) {
  const [editingPublicTest, setEditingPublicTest] = useState(false);
  const [editingSecretTest, setEditingSecretTest] = useState(false);
  const [publicTestCode, setPublicTestCode] = useState('');
  const [secretTestCode, setSecretTestCode] = useState('');
  const [savingTest, setSavingTest] = useState(false);

  // Initialize test code when question changes
  useEffect(() => {
    if (question) {
      setPublicTestCode(question.publicTestCode || '');
      setSecretTestCode(question.secretTestCode || '');
    }
  }, [question]);

  const handleEditPublicTest = () => {
    setEditingPublicTest(true);
  };

  const handleCancelPublicTest = () => {
    setEditingPublicTest(false);
    setPublicTestCode(question?.publicTestCode || '');
  };

  const handleEditSecretTest = () => {
    setEditingSecretTest(true);
  };

  const handleCancelSecretTest = () => {
    setEditingSecretTest(false);
    setSecretTestCode(question?.secretTestCode || '');
  };

  const savePublicTest = async () => {
    if (!isTeacher || !questionId || questionId === 'undefined' || questionId === 'null') {
      return;
    }

    setSavingTest(true);
    try {
      const response = await axios.put(`/questions/${questionId}`, {
        publicTestCode: publicTestCode
      });
      setEditingPublicTest(false);
      // Return the updated question so parent can update state
      return response.data.question;
    } catch (error) {
      console.error('Error saving public test:', error);
      alert('保存失败：' + (error.response?.data?.error || '请重试'));
      throw error;
    } finally {
      setSavingTest(false);
    }
  };

  const saveSecretTest = async () => {
    if (!isTeacher || !questionId || questionId === 'undefined' || questionId === 'null') {
      return;
    }

    setSavingTest(true);
    try {
      const response = await axios.put(`/questions/${questionId}`, {
        secretTestCode: secretTestCode
      });
      setEditingSecretTest(false);
      // Return the updated question so parent can update state
      return response.data.question;
    } catch (error) {
      console.error('Error saving secret test:', error);
      alert('保存失败：' + (error.response?.data?.error || '请重试'));
      throw error;
    } finally {
      setSavingTest(false);
    }
  };

  return {
    editingPublicTest,
    editingSecretTest,
    publicTestCode,
    secretTestCode,
    savingTest,
    setPublicTestCode,
    setSecretTestCode,
    handleEditPublicTest,
    handleCancelPublicTest,
    handleEditSecretTest,
    handleCancelSecretTest,
    savePublicTest,
    saveSecretTest
  };
}

